module.exports = __webpack_public_path__ + "assets/b114.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b114.png
// module id = 586
// module chunks = 0